/**
 * Dlaždica Star Wars: Outer Rim v knižnici portálu. Hra je samostatný projekt
 * (`outer-rim/` v repozitári, vlastný server aj build na `/outer-rim/`) — dlaždica
 * je len odkaz, portál o hre nič iné nevie. Obal je obrázok z krabice od používateľa
 * (`public/art/outer-rim/cover.webp`).
 */

import { GameCard } from '../../portal/GameCard.js';
import type { PortalTileProps } from '../registry.js';

export function OuterRimTile(_props: PortalTileProps) {
  return (
    <GameCard
      title="Star Wars: Outer Rim"
      status="wip"
      badge="Hrateľná beta"
      titleStyle={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', fontSize: '21px' }}
      players="1–4 hráči"
      duration="2–3 h"
      tags={['Vesmír', 'Kontrakty', 'Obchod', 'Aj proti AI']}
      description="Lovci odmien a pašeráci na okraji galaxie — plň kontrakty, obchoduj, vylepšuj loď a zbieraj slávu. Celá základná hra, online, na jednej obrazovke aj proti AI pašerákovi."
      onPlay={() => window.location.assign('/outer-rim/')}
      cover={
        <span className="libCover libCover--rim">
          <img className="libCover__img" src="/art/outer-rim/cover.webp" alt="Star Wars: Outer Rim" draggable={false} />
        </span>
      }
    />
  );
}
